goog.provide("shadow.js.shim.module$$mui$icons_material$List$default");
shadow.js.shim.module$$mui$icons_material$List$default = shadow.js.shim.module$$mui$icons_material$List.default;
